import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  Button,
  Form,
  Input,
  notification,
  Col,
  Row,
  Select,
  Card,
  Tooltip,
  Collapse,
  Table,
} from "antd";

import { getAuthuser } from "../../stored/mydata";

import apiGetProject from "../../api/deviceRoomP/getProject";
import apiGetHouse from "../../api/deviceRoomP/getHouse";
import apiGetDeviceInRoom from "../../api/deviceRoomP/getDeviceInRoom";
import apiGetRoomInHouse from "../../api/deviceRoomP/getRoomInHome";

export default function HomeDevice(props) {
  const authUser = useSelector(getAuthuser);
  const [api, contextHolder] = notification.useNotification();

  const [house, setHouse] = useState({
    house_number: "",
    room_code: "",
    unit_number: "",
  });

  const [optionProject, setOptionProject] = useState([]);
  const [optionHouse, setOptionHouse] = useState([]);
  const [deviceInRoom, setDeviceInRoom] = useState([]);

  const columnsDevice = [
    {
      title: "ID",
      dataIndex: "id",
      width: "6%",
      sorter: (a, b) => a.id - b.id,
      render: (_, record) => <div>{record.id}</div>,
    },
    {
      title: "Device_name",
      dataIndex: "device_name",
      width: "10%",
      ellipsis: {
        showTitle: false,
      },
      render: (_, record) => (
        <Tooltip placement="topLeft" title={record.device_name}>
          <div>{record.device_name}</div>
        </Tooltip>
      ),
    },
    {
      title: "Id_name",
      dataIndex: "device_id_name",
      width: "40%",
      ellipsis: {
        showTitle: false,
      },
      render: (_, record) => (
        <Tooltip placement="topLeft" title={record.device_id_name}>
          <div>{record.device_id_name}</div>
        </Tooltip>
      ),
    },
    {
      title: "Model",
      dataIndex: "device_model",
      width: "10%",
      ellipsis: {
        showTitle: false,
      },
      render: (_, record) => (
        <Tooltip placement="topLeft" title={record.device_model}>
          <div>{record.device_model}</div>
        </Tooltip>
      ),
    },
    {
      title: "Type",
      dataIndex: "device_type",
      width: "10%",
      ellipsis: {
        showTitle: false,
      },
      render: (_, record) => (
        <Tooltip placement="topLeft" title={record.device_type}>
          <div>{record.device_type}</div>
        </Tooltip>
      ),
    },
  ];

  const getProject = async () => {
    try {
      const projectPromise = new Promise((resolve, reject) => {
        apiGetProject(authUser, (err, res) => {
          if (err) {
            reject(err);
          } else {
            resolve(res);
          }
        });
      });

      const [projectRes] = await Promise.all([projectPromise]);

      // houseRes
      if (projectRes["data"]) {
        var dataProject = [];
        projectRes["data"].map((e, i) => {
          dataProject.push({ ...e, value: e.id, label: e.name });
        });
        setOptionProject(dataProject);
      } else {
        props.showMessage(false, { description: "ดึงข้อมูล project ไม่ได้" });
      }
      // houseRes
    } catch (error) {
      console.log(error);
    }
  };

  const onChangeProject = async (value) => {
    const housePromise = new Promise((resolve, reject) => {
      apiGetHouse(authUser, value.id, (err, res) => {
        if (err) {
          reject(err);
        } else {
          resolve(res);
        }
      });
    });

    const [houseRes] = await Promise.all([housePromise]);

    // houseRes
    if (houseRes["data"]) {
      var dataHouse = [];
      houseRes["data"].map((e, i) => {
        dataHouse.push({ ...e, value: e.id, label: e.house_number });
      });
      setOptionHouse(dataHouse);
    } else {
      props.showMessage(false, { description: "ดึงข้อมูล house ไม่ได้" });
    }
    // houseRes
  };

  const getDataInHouse = async (value) => {
    try {
      const devicehousePromise = new Promise((resolve, reject) => {
        apiGetDeviceInRoom(authUser, value, (err, res) => {
          if (err) {
            reject(err);
          } else {
            resolve(res);
          }
        });
      });

      const roomhousePromise = new Promise((resolve, reject) => {
        apiGetRoomInHouse(authUser, value, (err, res) => {
          if (err) {
            reject(err);
          } else {
            resolve(res);
          }
        });
      });

      const [devicehouseRes, roomhouseRes] = await Promise.all([
        devicehousePromise,
        roomhousePromise,
      ]);

      // roomhouseRes
      var dataRoom = [];
      if (roomhouseRes["data"]) {
        roomhouseRes["data"].map((e) =>
          dataRoom.push({ ...e, value: e.id, label: e.room_name }),
        );

        // setOptionRooms(dataRoom);
      }
      // roomhouseRes

      // devicehouseRes
      var combinedRooms = [];
      if (devicehouseRes["data"] && dataRoom) {
        for (let i = 0; i < dataRoom.length; i++) {
          var combinedDevice = devicehouseRes["data"].filter(
            (e) => dataRoom[i].room_name === e.room_name,
          );

          if (combinedDevice.length > 0) {
            combinedRooms.push({
              ...dataRoom[i],
              // devices: combinedDevice,
              children: (
                <div>
                  <Table
                    className="pagination-cardMeeting"
                    columns={columnsDevice}
                    dataSource={combinedDevice}
                    pagination={{
                      defaultPageSize: 10,
                      showSizeChanger: true,
                      pageSizeOptions: ["10", "20", "50", "100"],
                    }}
                    scroll={{
                      x: "auto",
                    }}
                  />
                </div>
              ),
            });
          }
        }
        setDeviceInRoom(combinedRooms);
      }
      // devicehouseRes
    } catch (error) {
      console.log(error);
    }
  };

  const onChangeHouse = (value) => {
    setHouse(value);
    getDataInHouse(value["house_number"]);
  };

  useEffect(() => {
    getProject();
  }, []);

  return (
    <div>
      {contextHolder}
      <Card>
        <Row>
          <Col span={12}>
            <div>
              <div>กรุณาเลือกโปรเจค</div>
              <div>
                <Select
                  showSearch
                  style={{
                    width: "100%",
                  }}
                  placeholder="Process"
                  size="large"
                  options={optionProject}
                  onChange={(value, option) => {
                    onChangeProject(option);
                  }}
                />
              </div>
            </div>
          </Col>
          <Col span={12}></Col>
        </Row>
        <Row>
          <Col span={12}>
            <div>
              <div>กรุณาเลือกบ้าน</div>
              <div>
                <Select
                  showSearch
                  optionFilterProp="label"
                  style={{
                    width: "100%",
                  }}
                  placeholder="Process"
                  size="large"
                  options={optionHouse}
                  onChange={(value, option) => {
                    onChangeHouse(option);
                  }}
                />
              </div>
            </div>
          </Col>
          <Col span={12}>
            <div style={styles.showData}>
              <div>unit_number : {house["unit_number"]}</div>
              <div>room_code : {house["room_code"]}</div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Collapse items={deviceInRoom} defaultActiveKey={["0"]} />
          </Col>
        </Row>
      </Card>
    </div>
  );
}

const styles = {
  showData: {
    margin: "18px 10px 5px 20px",
    color: "#4F4F4F",
    fontSize: "14px",
    fontWeight: "300",
    lineHeight: "22px",
  },
};
